import Vue from 'vue'
import App from './index.vue'
import router from './router'
import { store } from '../../store'
import { Tab, Tabs} from "vant";
import '../../entity/ulink_pull_entity'

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()

import waterfall from 'vue-waterfall2'
import MyNavBar from "@/components/MyNavBar.vue";
import BottomBar from "../../components/BottomBar";
import GlobalPlayer from "../../components/GlobalPlayer";
import mixin from "@/mixin"
Vue.use(waterfall)
Vue.component('my-nav-bar', MyNavBar)
Vue.component('my-bottom-bar', BottomBar)
Vue.component("g-player", GlobalPlayer)
Vue.mixin(mixin)
Vue.use(Tab)
Vue.use(Tabs)
// 多页跳转
const pagesJump = (path) => {
    if (location.hostname === 'localhost') {
        window.location.href = path;
    } else {
        const http = window.location.protocol + '//' + location.hostname + ':' + location.port;
        window.location.href = http + '/h5' + path; //（服务器的路径）
    }
}
Vue.prototype.pagesJump = pagesJump;

/* 网页title */
Vue.use(require('vue-wechat-title'))

// 用户交互过之后就可以播放了
window.onhashchange = ()=>{
    Vue.prototype.isFirst = false
}

/* 全局css */
import '../../assets/css/common.css'

/* swiper */
// import 'swiper/dist/css/swiper.css'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// // import style
// import 'swiper/css/swiper.css'
// Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

/* vue-video-player */
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

// vant组件
import {
    Search,
    Button,
    Tabbar,
    TabbarItem,
    List,
    Loading,
    Cell,
    CellGroup,
    Image,
    Lazyload,
    Swipe,
    SwipeItem,
    PullRefresh,
    Overlay,
    Sticky,
    Popup,
    ActionSheet,
    Icon,
    Uploader,
    Field,
    Toast
} from "vant"
Vue.use(Button)
    .use(Tabbar)
    .use(TabbarItem)
    .use(Loading)
    .use(Cell)
    .use(CellGroup)
    .use(Image)
    .use(Lazyload)
    .use(List)
    .use(Swipe)
    .use(SwipeItem)
    .use(PullRefresh)
    .use(Overlay)
    .use(Sticky )
    .use(Popup )
    .use(ActionSheet)
    .use(Search)
    .use(Icon)
    .use(Uploader)
    .use(Field)
    .use(Toast)
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
